module.exports = require("insomnia-libcurl");